module.exports = __webpack_public_path__ + "static/img/man_glove_2.6f94475.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/man_glove_2.png
// module id = 718Q
// module chunks = 0